<template>

    <div class="full-width-overflow-y" :style="styleObj" >
        <HomeHeader
            :returnLabel="i18n.tkey('lang_return')"
            :useChatBtn="false"
            @clickBackBtn="returnFunc"
            v-if="false !== fullScreen"
        />

        <iframe ref="chatRoomIframeDom" :src="chatRoomUrl" seamless="seamless"></iframe>

    </div>

</template>

<script setup>

import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
import {getCurrentInstance, inject, onBeforeMount, onUnmounted, ref, toRef} from "vue";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import {usePageinfo} from "@/stores/pageinfo";
import chatApi from "@/request/chatApi";

const props = defineProps(["fullScreen"])

const i18n = inject("i18n")
const { proxy } = getCurrentInstance()

const styleObj = ref({})
const userInfoRef = toRef(useUserinfo())
const pageInfoRef = toRef(usePageinfo())
const chatRoomUrl = ref(null)

let chatIframeReadyFlag = false
let chatReadyFunc = null

function returnFunc(){
    proxy.$router.back()
}

function handleChatMsgEvent(e){
    chatIframeReadyFlag = true

    if (e.data.type == 'chatReady'){
        if (null != chatReadyFunc && typeof chatReadyFunc === "function"){
            const func = chatReadyFunc
            chatReadyFunc = null
            func()
        }
    }else{
        handleChatIframeEvent(e)
    }

}

function handleChatIframeEvent(e){

    if (e.data.type == "goProductQuotation"){
        goProductQuotation(e.data.data)
    }
}

function goProductQuotation(code) {
    // quotationCompanyCode.value = code
    //
    // displayView.value = "productQuotation"
    // emits("exec-command-complete", "openPersonChat", -1)
}

async function openPersonChat(login, flag) {
    const request = chatApi.openPersonalRoom
    const params = request.getParams()

    params.token = userInfoRef.value.token
    params.users[0].account = login

    request.send(params, (res) => {
        const datas = {
            roomid: res.data,
        }

        if (flag){
            datas.goMaterialFlag = true
        }

        proxy.$refs.chatRoomIframeDom.contentWindow.postMessage({ type: 'goUserRoom',  data: datas }, '*')
    })

}

async function goMaterialChat(login, url){
    const request = chatApi.openPersonalRoom
    const params = request.getParams()

    params.token = userInfoRef.value.token
    params.users[0].account = login

    request.send(params, (res) => {
        proxy.$refs.chatRoomIframeDom.contentWindow.postMessage({ type: 'goUserRoomAndMessage',  data: {roomId: res.data, message: url} }, '*')
    })

}

defineExpose({
    openPersonChat,
    goMaterialChat
})

onBeforeMount(() => {

    if (props.fullScreen !== false){
        styleObj.value = {
            width: `${window.innerWidth}px`,
            height: `${window.innerHeight}px`
        }

        chatRoomUrl.value = `${proxy.$ShopopeeUrl}/enterChatRoom?login=${userInfoRef.value.login}&password=${userInfoRef.value.password}&tag=3dshopopee`
    }

    if (null != userInfoRef.value.login && null != userInfoRef.value.token && null != pageInfoRef.value.chatLogin){
        if (null != pageInfoRef.value.chatSendMsg){
            chatReadyFunc = () => {
                goMaterialChat(pageInfoRef.value.chatLogin, pageInfoRef.value.chatSendMsg)
                pageInfoRef.value.chatLogin = null
                pageInfoRef.value.chatSendMsg = null
            }
        }else{
            chatReadyFunc = () => {
                openPersonChat(pageInfoRef.value.chatLogin)
                pageInfoRef.value.chatLogin = null
            }
        }
    }

    window.addEventListener("message", handleChatMsgEvent)

})

onUnmounted(() => {
    window.removeEventListener("message", handleChatMsgEvent)
})

</script>

<style scoped>

.full-width-overflow-y{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    text-align: left;
    position: relative;
}

iframe {
    width: calc(100% + 2px);
    /* height: calc(100% + 163px); */
    height: calc(100% - 80px);
    border: none;
    margin-left: -1px;
}

</style>